import { css } from '@adornis/chemistry/directives/css.js';
import { XTodoPersonalList } from '@adornis/todo/client/x-todo-personal-list.js';
import { permissionGuard } from '@adornis/user-forms/permission-guard.js';
import { ANY_CONTEXT } from '@adornis/users/db/a-roles.js';
import { ChancenDialogAddTodo } from '@chancenwerk/components/dialogs/chancen-dialog-add-todo.js';
import { ChancenPermission } from '@chancenwerk/db/permissions.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import './cr-card-button.js';

/**
 * @customElement cr-todo-personal-list
 */
@customElement('cr-todo-personal-list')
export class ChromiumTodoPersonalList extends XTodoPersonalList {
  protected override _inputField() {
    return html`
      ${permissionGuard(
        ChancenPermission.global.CREATE_TODOS,
        () => html`
          <cr-card-button
            icon="add"
            @click=${() => {
              void ChancenDialogAddTodo.showPopup();
            }}
          >
            Todo anlegen
          </cr-card-button>
        `,
        {
          // Tippy doesnt rerender on size change. The todos are rendered after tippy is appended to the dom. This is an empty flex to ensure tippy doesnt render outside of the viewport
          forbiddenTemplate: html` <cr-flex flex ${css({ minWidth: '200px' })}></cr-flex> `,
          context: ANY_CONTEXT,
        },
      )}
    `;
  }
}
